import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { User } from './user.model';
import { BaseService } from '../base.service';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { Access } from '../featurePermission/access';

@Injectable()
export class UserService extends BaseService {

  constructor(protected http: HttpClient, protected router: Router, protected cookieService: CookieService) {
    super(http, router, cookieService);
  }

  public getUser(userId: string): Observable<User> {
    return this.get<User>(`/users/${ userId }`, this.httpOptions());
  }

  public update(user: User): Observable<User> {
    return this.put<User>(`/users/${ user.id }`, user, this.httpOptions());
  }

  public changePassword(user: string,  pwd: { newPwd: string; oldPwd: string }): Observable<User> {
    return this.put<User>(`/users/${ user }/password`, pwd, this.httpOptions());
  }

  public updateAccess(user: string, access: Access): Observable<User> {

    return this.put<User>(`/users/${ user }/access`, access, this.httpOptions());
  }

  public create(user: User, association?: string): Observable<User> {
    let params: HttpParams = new HttpParams();

    if (!!association) {
      params = params.append('association', association);
    }

    return this.post<User>(`/users`, user, this.httpOptions(params));
  }

  public deleteUser(user: User, association?: string): Observable<User> {
    let params: HttpParams = new HttpParams();

    if (!!association) {
      params = params.append('association', association);
    }

    return this.delete<User>(`/users/${ user.id }`, this.httpOptions(params));
  }
}
